import React, { useState } from "react";
import PaymentSettings from "./PaymentSettings";
import { capitalizeFirstLetter } from "../../../utils/helper";

function Setting() {
  const [activeTab, setActiveTab] = useState("Payment Settings");
  const renderContent = () => {
    switch (activeTab) {
      case "Payment Settings":
        return <PaymentSettings />;
      default:
        return <PaymentSettings />;
    }
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="breadcrumb-title pe-3 mb-1">Settings</div>
      </div>
      <div className="col-lg-12 mb-2 d-flex justify-content-center align-items-center ">
        <ul className="nav nav-tabs custom-tabs fw-semibold ">
          {["Payment Settings",].map((tab) => (
            <li className="nav-item" key={tab}>
              <button
                className={`nav-link ${activeTab === tab ? "active-tab" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {capitalizeFirstLetter(tab)}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-white mt-2 radius-10">{renderContent()}</div>
    </>
  );
}

export default Setting;
